import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions, mapGetters } from 'vuex';
import { LoadData } from '@/api/MaintainDeliveryNote2';
import util from '@/libs/util';
export default {
  data: function data() {
    return {
      buttons: [{
        name: 'add',
        target: ['listshow']
      }],
      isShowDELIVERY_NO: true,
      // 输入送货单号
      isShowVENDOR_CODE: true,
      // 输入供应商代码
      isShowVENDOR: true,
      // 输入供应商
      isShowSeach: true,
      // 查询
      isShowAdd: true,
      // 新增
      isShowExport: false,
      // 数据导出
      isShowBlack: false,
      // 返回
      isShowSave: false,
      // 保存
      isShowAddRow: false,
      // 新增明细
      isShowEditOrder: false,
      // 修改明细
      isShowAuditOrder: false,
      // 审核
      isShowUnAuditOrder: false,
      // 反审核
      isShowPrinter: false,
      // 打印
      isShowNext: true,
      // 上一张下一张
      isShowCancellation: false,
      // 作废
      isShowCancel: false,
      // 取消
      isShowSelectOrder: false,
      // 选择送货单
      isCreatePartBarcode: false,
      // 生成标签
      isShowSendMail: false,
      // 发送邮件
      VENDOR_CODE: null,
      // 供应商
      selectLoading: false,
      vendorOptions: [],
      DELIVERY_NO: null,
      // 送货单号
      OrderList: [],
      // 单据列表
      nextIndex: null,
      orderStatus: null,
      // 单据状态
      orderInfo: {} // 单据内容

    };
  },
  mounted: function mounted() {},
  methods: {
    //通过ID获取单据信息
    asyncStatus: function asyncStatus(ID) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, res, row;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  Page: 1,
                  // 当前页
                  Limit: 10,
                  // 分页大小
                  Data: {
                    ORGANIZE_ID: util.cookies.get('ORG_ID'),
                    ID: ID
                  }
                };
                _context.next = 3;
                return LoadData(params);

              case 3:
                res = _context.sent;
                console.log('通过ID获取单据信息', res);

                if (!(res.code === 0)) {
                  _context.next = 15;
                  break;
                }

                if (!(res.data.Items.length > 0)) {
                  _context.next = 11;
                  break;
                }

                row = res.data.Items[0];

                _this.controlBtnShow(row.STATUS);

                _context.next = 13;
                break;

              case 11:
                _this.$message.warning('获取单据信息失败');

                return _context.abrupt("return");

              case 13:
                _context.next = 16;
                break;

              case 15:
                _this.$message.warning('res.message');

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 发送邮件
    handleSendMail: function handleSendMail() {
      this.$emit('onSendMail');
    },
    // 设置状态
    setStatus: function setStatus(status) {
      // console.log(status);
      this.controlBtnShow(status);
    },
    setHeaderForDELIVERY_NO: function setHeaderForDELIVERY_NO(row) {
      this.orderStatus = row.STATUS; // this.controlBtnShow(row.STATUS)
    },
    // 点击打印
    handlePrint: function handlePrint() {
      this.$emit('onHandlePrint');
    },
    // 点击导出--明细
    handleExportDetailData: function handleExportDetailData() {
      this.$emit('onHandleExportDetailData');
    },
    // 点击作废
    handelCancelBill: function handelCancelBill() {
      this.$emit('onCancelBillOrder');
    },
    // 点击反审核
    UnCheckBillOrder: function UnCheckBillOrder() {
      this.$emit('onUnCheckBillOrder');
    },
    // 点击审核
    handelAuditOrder: function handelAuditOrder() {
      this.$emit('onHandleAuditOrder');
    },
    // 控制按钮显示
    controlBtnShow: function controlBtnShow(status) {
      // console.log('控制按钮显示 status=====',status);
      if (status === 1) {
        // 未确认
        this.isShowAdd = false;
        this.isShowBlack = true;
        this.isShowAuditOrder = true;
        this.isShowUnAuditOrder = false;
        this.isShowEditOrder = true;
        this.isShowPrinter = false;
        this.isShowCancellation = true;
        this.isShowSendMail = true;
      } else if (status === 2) {
        // 已审核
        this.isShowAuditOrder = false;
        this.isShowEditOrder = false;
        this.isShowUnAuditOrder = true;
        this.isShowPrinter = true;
        this.isShowCancellation = false;
        this.isShowSendMail = true;
      } else if (status === 3) {
        // 作废
        this.isShowAuditOrder = false;
        this.isShowEditOrder = false;
        this.isShowUnAuditOrder = false;
        this.isShowPrinter = false;
        this.isShowCancellation = false;
        this.isShowSendMail = true;
      } else if (status === 4) {
        // 在途
        this.isShowEditOrder = false;
        this.isShowUnAuditOrder = true;
        this.isShowPrinter = true;
        this.isShowAuditOrder = false;
        this.isShowCancellation = false;
        this.isShowSendMail = true;
      } else if (status === 5) {
        // 收货
        this.isShowPrinter = true;
        this.isShowUnAuditOrder = false;
        this.isShowAuditOrder = false;
        this.isShowEditOrder = false;
        this.isShowCancellation = true;
      } else if (status === 9) {
        // 全关闭
        this.isShowUnAuditOrder = false;
        this.isShowAuditOrder = false;
        this.isShowEditOrder = false;
        this.isShowPrinter = false;
        this.isShowCancellation = false;
      }
    },
    // 点击上一张
    handleUpNextOrder: function handleUpNextOrder() {
      this.$emit('getBackOrder');
    },
    // 点击下一张
    handleDownNextOrder: function handleDownNextOrder() {
      this.$emit('nextOrder');
    },
    // //获取供应商列表
    // async getVendorList(Key = ''){
    //     let params = {
    //         Page: 1,
    //         Limit: 20,
    //         Key
    //     }
    //     let res = await GetImsVendorLoadData(params)
    //     // console.log('供应商列表 res',res);
    //     this.selectLoading = false
    //     if(res.code === 0){
    //         this.vendorOptions = res.data.map(item=>{
    //             return {
    //                 key:item.ID,
    //                 value:item.CODE,
    //                 label:item.CODE + ' - ' + item.NAME
    //             }
    //         })
    //     }
    // },
    // //下拉框输入供应商
    // handleInputVendorSelect(value){
    //     // console.log(value);
    //     if(value !== ''){
    //         this.selectLoading = true
    //         this.getVendorList(value)
    //     }else{
    //         return
    //     }
    // },
    // 点击保存单据
    handleSaveOrder: function handleSaveOrder() {
      if (this.$MaintainDeliveryNote2State === 'editOrder') {
        this.$emit('onSaveEditOrder');
      } else if (this.$MaintainDeliveryNote2State === 'addOrder') {
        this.$emit('onSaveAddOrder');
      }
    },
    // 点击新增明细
    handleAddRow: function handleAddRow() {
      // console.log('单据操作状态 $MaintainDeliveryNote2State==>',this.$MaintainDeliveryNote2State);
      if (this.$MaintainDeliveryNote2State === 'addOrder') {
        // this.$emit('onBeforeShowAddRowDialogForaddOrder')
        this.$emit('onHandelAddRow');
      } else {
        // this.Bus.emit('onBeforeShowAddRowDialog')
        this.$emit('onHandelAddRow');
      }
    },
    // 点击返回
    handleBlackBtn: function handleBlackBtn() {
      this.Bus.emit('onHandleBlackForShow');
    },
    // 点击取消
    handleCancelBtn: function handleCancelBtn() {
      this.$emit('onHandleCancel');
    },
    // 点击修改
    handleEditOrder: function handleEditOrder() {
      this.$emit('onClickEditOrder');
      this.$setOrderStatu('editOrder');
    }
  },
  watch: {
    // 送货单
    $MaintainDeliveryNote2State: {
      handler: function handler(nawValue) {
        // console.log('单据操作状态 $MaintainDeliveryNote2State==>',nawValue);
        if (nawValue === 'listShow') {
          // 订单列表
          this.isShowDELIVERY_NO = true;
          this.isShowVENDOR_CODE = true;
          this.isShowVENDOR = true;
          this.isShowSeach = true;
          this.isShowAdd = true;
          this.isShowBlack = false;
          this.isShowSave = false;
          this.isShowAddRow = false;
          this.isShowNext = false;
          this.isShowCancel = false;
          this.isShowSendMail = false;
          this.controlBtnShow(9);
        } else if (nawValue === 'addOrder') {
          // 新增订单
          this.isShowDELIVERY_NO = false;
          this.isShowVENDOR_CODE = false;
          this.isShowVENDOR = false;
          this.isShowSeach = false;
          this.isShowAdd = false;
          this.isShowExport = false;
          this.isShowBlack = true;
          this.isShowSave = true;
          this.isShowAddRow = true;
          this.isShowNext = false;
          this.isShowCancel = false;
          this.isShowSendMail = false; // this.controlBtnShow(9)
        } else if (nawValue === 'orderShow') {
          // 订单明细
          this.isShowDELIVERY_NO = false;
          this.isShowVENDOR_CODE = false;
          this.isShowVENDOR = false;
          this.isShowSeach = false;
          this.isShowAdd = false;
          this.isShowExport = true;
          this.isShowSave = false;
          this.isShowAddRow = false;
          this.isShowCancel = false;
          this.isShowNext = true;
          this.isShowBlack = true;
          this.isShowEditOrder = false;
          this.isShowAuditOrder = true;
          this.isShowCancellation = false;
          this.isShowSendMail = true;
          this.controlBtnShow(this.orderStatus);
        } else if (nawValue === 'editOrder') {
          this.isShowDELIVERY_NO = false;
          this.isShowVENDOR_CODE = false;
          this.isShowVENDOR = false;
          this.isShowSeach = false;
          this.isShowAdd = false;
          this.isShowNext = false;
          this.isShowEditOrder = false;
          this.isShowAuditOrder = false;
          this.isShowCancellation = false;
          this.isShowBlack = false; // 返回

          this.isShowSave = true; // 保存

          this.isShowAddRow = true; // 新增明细

          this.isShowCancel = true; // 取消

          this.isShowExport = false;
          this.isShowSendMail = false;
        }
      },
      immediate: true
    }
  },
  computed: _objectSpread({}, mapGetters(['AnnouncementState'])),
  beforeDestroy: function beforeDestroy() {}
};